import React from 'react';
import { ParticipantStep } from '../../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../../contexts/main/biInterfaces';
import { SidebarLayoutButton } from '../../../../components/Buttons/SidebarLayoutButton/SidebarLayoutButton';
import {
  getFlatStepsList,
  getNextStepToComplete,
  getProgramProgress,
} from '../../../utils';
import { Props } from '../../interfaces';
import { classes } from './StartButton.st.css';
import { ChevronLeftSmall, ChevronRightSmall } from '@wix/wix-ui-icons-common';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { Challenges } from '../../../../../../../editor/types/Experiments';

export interface StartButtonProps {
  props: Props;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
}

export const StartButton: React.FC<StartButtonProps> = ({
  props,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
}) => {
  const { t } = props;
  const { experiments } = useExperiments();
  const isExperimentEnabled = experiments.enabled(
    Challenges.uniteNextAndCompleteButton,
  );
  const flatStepsList = getFlatStepsList(props);
  const { isProgramNotStarted } = getProgramProgress(flatStepsList);

  return (
    <SidebarLayoutButton
      disabled={getIsStartDisabled()}
      suffixIcon={
        isExperimentEnabled ? (
          <ChevronRightSmall className={classes.ltrArrow} />
        ) : null
      }
      prefixIcon={
        isExperimentEnabled ? (
          <ChevronLeftSmall className={classes.rtlArrow} />
        ) : null
      }
      onClick={() => {
        const nextStepToComplete = getNextStepToComplete(flatStepsList);
        if (nextStepToComplete) {
          setStep(nextStepToComplete);
        }

        sendBiButtonClick(ButtonNames.OverviewStartButton);
      }}
    >
      {isProgramNotStarted
        ? t('challenge.page.overview.start-btn')
        : t('challenge.page.overview.current-step')}
    </SidebarLayoutButton>
  );
};
